import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router';
import { paths } from 'src/routes/paths';
import { useProductsStore } from 'src/store/products/products.store';
import * as Yup from 'yup';

const STATUS_OPTIONS = ['active', 'inactive'];
const STATUS_LABEL = ['Ativo', 'Inativo'];

const HIGHLIGHT_OPTIONS = ['yes', 'no'];
const HIGHLIGHT_LABEL = ['Sim', 'Não'];

export default function useCategoryDetails() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();

  const [
    getCategoryDetails,
    resetCategoryDetails,
    updateCategory,
    createCategory,
    loadingCategoryDetails,
    categoryDetails,
  ] = useProductsStore((state) => [
    state.getCategoryDetails,
    state.resetCategoryDetails,
    state.updateCategory,
    state.createCategory,
    state.loadingCategoryDetails,
    state.categoryDetails,
  ]);

  const { pathname } = useLocation();
  const isEdit = pathname.includes('edit');

  useEffect(() => {
    if (id) {
      getCategoryDetails(id);
    } else {
      resetCategoryDetails();
    }
  }, []);

  const defaultValues = useMemo(
    () => ({
      name: categoryDetails?.name || '',
      description: categoryDetails?.description || '',
      status: categoryDetails?.status || 'active',
    }),
    [categoryDetails]
  );

  const promotionSchema = Yup.object().shape({
    name: Yup.string().required('Campo obrigatório!'),
    description: Yup.string().required('Campo obrigatório!'),
    status: Yup.string(),
  });

  const methods = useForm({
    resolver: yupResolver(promotionSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    watch,
    formState: { isSubmitting },
  } = methods;

  const values = watch();

  useEffect(() => {
    if (defaultValues) {
      reset(defaultValues);
    }
  }, [categoryDetails, reset, defaultValues]);

  const onSubmit = handleSubmit(async (data: any) => {
    try {
      const updatedData = {
        id: isEdit ? id : null,
        name: data.name,
        description: data.description,
        status: data.status,
      };

      if (isEdit) {
        await updateCategory(updatedData);
        enqueueSnackbar('Categoria atualizado com sucesso!');
        navigate(`${paths.dashboard.themesCategoriesList}?tab=categories`);
      } else {
        await createCategory(updatedData);
        enqueueSnackbar('Categoria criado com sucesso!');
        navigate(`${paths.dashboard.themesCategoriesList}?tab=categories`);
      }
    } catch (error) {
      console.error(error);
    }
  });

  return {
    isEdit,
    loadingCategoryDetails,
    methods,
    values,
    isSubmitting,
    STATUS_OPTIONS,
    STATUS_LABEL,
    onSubmit,
    navigate,
    enqueueSnackbar,
    HIGHLIGHT_OPTIONS,
    HIGHLIGHT_LABEL,
  };
}
